import React from "react";
import Styles from './styles.module.scss';
import {useTranslation} from "react-i18next";

const CabinetEventsTable = () => {
    const { t } = useTranslation();
    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.ftfCard}`}>
                <div className={`${Styles.contentWrapTitle}`}>{t('Выберите событие')}:</div>
                <div className={`${Styles.contentBox}`}>
                    <div className={`${Styles.contentBoxCommingNote}`}>{t('Уже скоро...')}</div>
                </div>
            </div>
        </section>
    );
};

export default CabinetEventsTable;